import { useV2ListBlueprintsForAccountQuery } from "@generated";
import { PreviewTableItem } from "../types";

interface Params {
  serviceId: string;
  currentPage: number;
}

const useListBlueprintsForService = ({ serviceId, currentPage }: Params) => {
  let customError: string | null = null; // Declare customError

  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  const { data, error, isLoading, refetch, isFetching } =
    useV2ListBlueprintsForAccountQuery({
      filter: { "service-id": serviceId },
      page: {
        number: currentPage,
        size: 5,
      },
    });

  let blueprints: PreviewTableItem[] = [];

  if (data?.data) {
    try {
      blueprints = data.data.map((blueprint) => {
        if (!blueprint.id) {
          throw new Error("Missing blueprint.id");
        }
        if (!blueprint.attributes?.name) {
          throw new Error("Missing blueprint.attributes.name");
        }

        return {
          id: String(blueprint.id),
          name: blueprint.attributes.name,
        };
      });

      if (!data.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data.meta["record-count"],
        pageCount: data.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }
  return {
    blueprints,
    blueprintsLoading: isLoading,
    blueprintsError: error ?? customError,
    blueprintsPageMeta: pageMeta,
    blueprintsRefetch: refetch,
    blueprintsFetching: isFetching,
  };
};
export default useListBlueprintsForService;
